import { Scene } from "phaser";

import { GButton } from "../gameobjects/GButton";

import { unixToDate, getDrawByID, datetimeToUnixTimestamp, stringToNumberArray , formatNumberWithCommas} from '../utils';
import { WinningNumbers } from "../gameobjects/WinningNumbers";

// The HUD scene is the scene that shows the points and the remaining time.
const COLOR_BLUE = "#00FFF0";
const COLOR_DIMM = "#757B8C";
const COLOR_DARK = 0x212121;
export class ResultsScene extends Scene {
    
    constructor() {
        super("ResultsScene");

    }

    init(data) {
        //this.cameras.main.fadeIn(500, 0, 0, 0);
        //console.log('init', data);
        const { draw_date_id } = data;
        this.draw_date_id = draw_date_id;
        if(draw_date_id == undefined) {
            this.draw_date_id = this.registry.get('latest_draw');
            
        }
    }

    async create() {

        //console.log("this.draw_date_id", this.draw_date_id);
        const response = await getDrawByID(this.registry.get('gamecode'), this.draw_date_id)

        if(response.status !== 200){

            let message = response.data.error || "Network error"
            this.scene.start("ErrorScene", {message:message})
            return
        }

        this.drawInfo = response.data;

        const containerY = (62  +16 + 28 +24) *2;
        const HeaderY = (62 +16 + 24 ) *2

        this.numberGrid = [];

        


        this.title = this.add.text(this.scale.width/2, (62 +16 + 24 ) *2, `RESULTS`,  { fontFamily: 'Oswald', fontSize: 48, color: '#ffffff' }).setOrigin(0.5);
        this.title.setFontStyle('700')

        const ButtonBack = new GButton(this, this.scale.width/2 -319, (62 +16 + 24 ) *2, {
            texturePack: "pack", 
            idleTexture: 'arrow back_ios.png',
            clickedTexture: 'arrow back_ios.png',
            disabledTexture: 'arrow back_ios.png',
            onClick: () => {
                //console.log('Button ButtonBack!');
                this.scene.start("MenuScene");
             }
        });

        ButtonBack.setScale(0.85);


        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  containerY + 52, 'pack', 'header-main.png', 343*2, 104, 32, 32);
        //this.TicketsHeader.setScale(0.75);
    
        const game_over_timeout = datetimeToUnixTimestamp(this.drawInfo.draw_date)

        this.DrawDate = unixToDate( game_over_timeout );
    
        this.drawDateText = this.add.text(this.scale.width/2-319,  containerY +52, `DRAW DATE` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0, 0.5);
        this.drawDateText.setFontStyle('700')
    
        //console.log("this.drawDateText.bounds", this.drawDateText);
    
        this.drawDateDate = this.add.text(this.drawDateText.x + this.drawDateText.width + 16,  containerY +50, this.DrawDate ,  { fontFamily: 'Oswald', fontSize: 30, color: '#ffffff' }).setOrigin(0, 0.5);
        this.drawDateDate.setFontStyle('700')

        this.drawNumber = this.add.text(this.scale.width/2+319,  containerY + 50, this.drawInfo.draw_date_id ,  { fontFamily: 'Oswald', fontSize: 34, color: '#ffffff' }).setOrigin(1,0.5);
        this.drawNumber.setFontStyle('700')

        this.drawNumberText = this.add.text( this.drawNumber.x - this.drawNumber.width - 16 ,  containerY +52, `DRAW NO.` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(1,0.5);
        this.drawNumberText.setFontStyle('700')

        this.boxHight = this.scale.height/2;
    
        this.boxGraphics = this.add.graphics();

        this.boxGraphics.fillStyle(0x212121, 1);
    
        // //  Using an object to define a different radius per corner
        this.boxGraphics.fillRoundedRect(this.scale.width/2-342, containerY +104, 343*2, 103*2, { tl: 0, tr: 0, bl: 32, br: 32 });


        this.WinningNumbersContainer = this.add.container(this.scale.width/2-280,containerY +144)

        this.createGridWinning(stringToNumberArray(this.drawInfo.winning_numbers))

        const ticketNumberText = this.add.text(this.WinningNumbersContainer.getBounds().width/2-40,0, `WINNING NUMBERS`, {
            fontFamily: 'Oswald', 
            fontSize: '32px',
            color: '#fff',
        }).setOrigin(0.5); // Set origin to top-left;

        ticketNumberText.setFontStyle('700')



        // Tabs
        this.MyResultsText = this.add.text(this.scale.width/2-260, this.scale.height/2 - 124, ` My Results`,  { fontFamily: 'Oswald', fontSize: 36, color: COLOR_BLUE }).setOrigin(0,0.5).setInteractive();
        this.MyResultsText.setFontStyle('700')


       


        this.WinningSharesText = this.add.text(this.scale.width/2+260, this.scale.height/2 - 124, ` Winning Shares`,  { fontFamily: 'Oswald', fontSize: 36, color: COLOR_DIMM }).setOrigin(1,0.5).setInteractive();
        this.WinningSharesText.setFontStyle('700')
       
      

       
        // Add the text object to this container
        this.WinningNumbersContainer.add(ticketNumberText);




        this.TicketsHeader = this.add.nineslice(this.scale.width/2,  this.scale.height/2 - 20, 'pack', 'header-main.png', 343*2, 104, 32, 32);
        //this.TicketsHeader.setScale(0.75);

        this.totalPrizesText = this.add.text(this.scale.width/2-319,  this.scale.height/2 - 20, `TOTAL PRIZES` ,  { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0, 0.5);
        this.totalPrizesText.setFontStyle('700')

        this.totalPrizeAmountText = this.add.text(this.scale.width/2+319,  this.scale.height/2 - 20, `` ,  { fontFamily: 'Oswald', fontSize: 34, color: '#ffffff' }).setOrigin(1, 0.5);
        this.totalPrizeAmountText.setFontStyle('700')



        this.panel = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, y: this.scale.height/2+25,
            width:  343*2,
            height: 326*2,
            originY: 0,

            scrollMode: 0,
            background: this.rexUI.add.roundRectangle({
                color: COLOR_DARK,
                // strokeColor:"#FFFFF",
                radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            }),
            panel: {
                child: this.CreatePanel(this),//this.CreatePanel(this)
                //mask: { padding: 30, },
            },
            space: { left: 20, right: 20, top: 40, bottom: 20, panel: 10}
        })
            .layout()

        this.updateTicketList();



         // Create container
         const SHareContainer = this.add.container(this.scale.width / 2, this.scale.height / 2- 20);

          // Define the size of the container
        const containerWidth = 300;
        const containerHeight = 200;

        // Add a NineSlice background to the container
        const SharesHeaaders = this.add.nineslice(
            0, 0,              // x, y position within the container
            'pack', 'header-main.png', 343*2, 104, 32, 32
        );

        SharesHeaaders.setOrigin(0.5); // Center the background inside the container

        // Add a text object at the top of the container
        const titleText = this.add.text(-containerWidth -16, 0, 'WINNING SHARES', { fontFamily: 'Oswald', fontSize: 26, color: '#ffffff' }).setOrigin(0, 0.5);
        titleText.setFontStyle('700')
        // Add background and text to the container

        SHareContainer.add([SharesHeaaders]);

        // const dataArray = [
        //     { col1: 'Row1 Col1', col2: 'Row1 Col2', col3: 'Row1 Col3' },
        //     { col1: 'Row2 Col1', col2: 'Row2 Col2', col3: 'Row2 Col3' },
        //     { col1: 'Row3 Col1', col2: 'Row3 Col2', col3: 'Row3 Col3' },
        //     // ... more data
        // ];


        // const gridTable = this.rexUI.add.gridTable({
        //     x: this.cameras.main.width / 2,
        //     y: SHareContainer.getBounds().y + 404,
        //     width: 343*2,
        //     height: 650,

        //     scrollMode: 0, // Vertical scrolling

        //     background: this.rexUI.add.roundRectangle({
        //         color: COLOR_DARK,
        //         // strokeColor:"#FFFFF",
        //         radius: { tl: 0, tr: 0, bl: 32, br: 32 }
        //     }),

        //     table: {
        //         //cellWidth: undefined,
        //         cellHeight: 108,
        //         columns: 3,
        //         mask: {
        //             padding: 2
        //         },
        //         reuseCellContainer: true
        //     },

        //     space: {
        //         left: 10,
        //         right: 10,
        //         top: 10,
        //         bottom: 10,

        //         table: 10,
        //         header: 10,
        //         footer: 10,
        //     },

        //     // Optionally add a header
        //     header: this.add.text(0, 0, 'My Table Header', { fontSize: '20px', color: '#ffffff' }),

        //     items: dataArray
        // })
        // .layout();

        // gridTable
        //     .setCreateCellContainerCallback(this.createCellContainer.bind(this));

        this.sortedArray = [];
        if(this.drawInfo.winning_shares !== null  && this.drawInfo.winning_shares !== undefined){
            this.sortedArray = Object.keys(this.drawInfo.winning_shares)
                .sort((a, b) => b - a) // Sort keys in descending order
                .map((key, index) => {
                    const item = this.drawInfo.winning_shares[key];
                    return {
                        group: `Group ${index + 1}`, // Group number starts from 1
                        share_amount: item.shares * item.share_value, // shares * share_value
                        winners: item.shares
                    };
                });

            //console.log(this.sortedArray);

        }

       
        
        const gridTable = this.rexUI.add.scrollablePanel({
            x: this.scale.width/2, 
            y: SHareContainer.getBounds().y + 104,
            width:  343*2,
            height: 600,
            originY: 0,

            scrollMode: 0,
            background: this.rexUI.add.roundRectangle({
                color: COLOR_DARK,
                // strokeColor:"#FFFFF",
                radius: { tl: 0, tr: 0, bl: 32, br: 32 }
            }),
            panel: {
                child: this.CreatePanel(this),
                //mask: { padding: 30, },
            },
            space: { left: 40, right: 20, top: 40, bottom: 20, panel: 10}
        })
        .layout()
        
        gridTable.setVisible(false)

        const panelContent = gridTable.getElement('panel');
        let Tcontainer = this.createTableContainer(this.sortedArray)
        panelContent.add(Tcontainer);

        gridTable.layout();

       
        SHareContainer.add([titleText]);
        
        SHareContainer.setVisible(false)

        this.MyResultsText.on('pointerup', () => {
            this.MyResultsText.setColor(COLOR_BLUE);
            this.WinningSharesText.setColor(COLOR_DIMM)
            this.panel.setVisible(true)
            this.TicketsHeader.setVisible(true)
            this.totalPrizesText.setVisible(true)
            this.totalPrizeAmountText.setVisible(true)
            SHareContainer.setVisible(false)
            gridTable.setVisible(false)
        });

        this.WinningSharesText.on('pointerup', () => {
            this.MyResultsText.setColor(COLOR_DIMM);
            this.WinningSharesText.setColor(COLOR_BLUE)
            this.panel.setVisible(false)
            this.TicketsHeader.setVisible(false)
            this.totalPrizesText.setVisible(false)
            this.totalPrizeAmountText.setVisible(false)
            SHareContainer.setVisible(true)
            gridTable.setVisible(true)
        });

        if(this.drawInfo.tickets.length == 0){
            this.MyResultsText.setVisible(false)
            this.WinningSharesText.setVisible(false)
            SHareContainer.setVisible(true)
            gridTable.setVisible(true)
        }
        

    }


    CreatePanel(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 20 }
        })
    
        return panel;
    }

    createCellContainer(cell, cellContainer) {
        const scene = cell.scene;
        const item = cell.item;
        const index = cell.index;

        if (cellContainer === null) {
            cellContainer = scene.rexUI.add.sizer({
                orientation: 'horizontal',
                space: { left: 5, right: 5 }
            });

            const col1Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });
            const col2Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });
            const col3Text = scene.add.text(0, 0, '', { fontSize: '16px', color: '#FFFFFF' });

            cellContainer
                .add(col1Text, { proportion: 1, align: 'left' })
                .add(col2Text, { proportion: 1, align: 'left' })
                .add(col3Text, { proportion: 1, align: 'left' });

            cellContainer.setData('colTexts', [col1Text, col2Text, col3Text]);
        }

        const colTexts = cellContainer.getData('colTexts');
        colTexts[0].setText(item.col1);
        colTexts[1].setText(item.col2);
        colTexts[2].setText(item.col3);

        // Zebra striping
        const bgColor = (index % 2 === 0) ? 0xf0f0f0 : 0xffffff;

        // Remove previous background if exists
        const prevBg = cellContainer.getData('bg');
        if (prevBg) {
            prevBg.destroy();
        }

        // Add background rectangle
        const bg = scene.rexUI.add.roundRectangle(0, 0, 20, 20, 0, bgColor);
        cellContainer.addBackground(bg);
        cellContainer.setData('bg', bg);

        return cellContainer;
    }


    CreatePanel(scene) {
        var panel = scene.rexUI.add.sizer({
            orientation: 'y',
            space: { top: 0, bottom: 20 }
        })
    
        return panel;
    }


       // Method to create and display the grid of numbers as text objects
       createGridWinning(numbersArray) {
        const columns = 6;       // Number of columns
        const textSpacingX = (40 + 16)*2 ; // Horizontal space between text objects
        const textSpacingY = (40 + 16)*2; // Vertical space between text objects

        for (let i = 0; i < numbersArray.length; i++) {
            const number = numbersArray[i];

            // Calculate the x and y position for each text object
            const x = (i % columns) * textSpacingX;
            const y = Math.floor(i / columns) * textSpacingY + 88;

            // Create the text object for the current number
            
            const numberCircle = this.add.sprite(x, y, 'pack' ,'Lotto Number - Winner - Default.png');

            this.WinningNumbersContainer.add(numberCircle)
            
            const numberText = this.add.text(x, y, number.toString(), {
                fontFamily: 'Montserrat',
                fontSize: '30px',
                color: '#fff',
            });
            numberText.setOrigin(0.5)
            numberText.setFontStyle('700')


            this.WinningNumbersContainer.add(numberText)
        }
    }


    updateTicketList(){
        var sum = 0
        try {
            this.panel.getElement('panel').removeAll(true);    
        } catch (error) {
            console.log(error)
        }
        
        for (let index = 0; index < this.drawInfo.tickets.length; index++) {
            const element = this.drawInfo.tickets[index];
           sum += +element.prize_amount
           
           var lastBoxY = 360;
           this.currentBound = 20
       
           //92, lastBoxY
           this.numberGrid[index] = new WinningNumbers(this, 0 , 0, {winningNumbers: this.drawInfo.winning_numbers, numbersArray: this.drawInfo.tickets[index], ticketNumber: index });
           //this.ticketContainer.add(this.numberGrid[index]);
           //if(index > 0){
            const bounds = this.numberGrid[index].getBounds()
            
            lastBoxY = bounds.height + bounds.y + 50
            
            this.currentBound = bounds.height;
            //}

           this.panel
           .getElement('panel')
           .add(
                this.numberGrid[index],
                {
                    proportion: 0,
                    align: 'left',
                    padding: {left: 44, right: 0, top: 0 , bottom: this.currentBound + 36},
                    expand: false,
                    fitRatio: 0,  
                    offsetX: 0,
                    //offsetY: lastBoxY,
                }
           );
           this.panel
           .getElement('panel')
           
        }

        this.panel
        .getElement('panel')
        .addSpace().layout()

        //this.panel.setMinSize(this.panel.width, 346*2).layout();
        this.panel.layout()
        //console.log("full sum:", sum)
        this.totalPrizeAmountText.setText(`$${formatNumberWithCommas(sum)}`);

    }


    // Create a Container for "Table" Type
    createTableContainer(item) {

        const tableContainer = this.rexUI.add.gridSizer({
            column: 3,
            width: 300*2,
            row: item.length + 1, // +1 for headers
            space: { column: 90, row: 80 },
            //background: roundedRect,
            //rowProportions: 1,
        });


        // CREATE HEADER
        

        

        


        const Header1 = this.add.text(0, 0, `PRIZE\nGROUP`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header1.setOrigin(0.5)
        Header1.setFontStyle('700')

        tableContainer.add(Header1, 0, 0, 'center', 0, false);


        const Header2 = this.add.text(0, 0, `SHARE\nAMOUNT`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header2.setOrigin(0.5)
        Header2.setFontStyle('700')

        tableContainer.add(Header2, 1, 0, 'center', 0, false);

        const Header3 = this.add.text(0, 0, `NO. OF\nWINNING SHARES`, {
            fontSize: '24px',
            fontFamily: 'Montserrat',
            color: '#F9F9FF',
            align: 'center',
            lineSpacing: 10,
            wordWrap: { width:  186*2, useAdvancedWrap: true }
        });
        Header3.setOrigin(0.5)
        Header3.setFontStyle('700')

        tableContainer.add(Header3, 2, 0, 'center', 0, false);



        // Add Rows
        item.forEach((row, rowIndex) => {
            //console.log("row", row)
            const isEvenRow = rowIndex % 2 === 0; // Determine if the row is even

            const rowBackground = this.add.graphics();
            rowBackground
                .fillStyle(isEvenRow ? 0xf0f0f0 : 0xdcdcdc) // Alternate row color
                .fillRect(0, 0, 560, 40); // Adjust the row size as needed

            // // Add the background to the table
            tableContainer.addBackground(rowBackground)// background =this.rexUI.add.roundRectangle(0, 0, 2, 2, 10, "0x0000ff");

            const text = this.add.text(0, 0, row.group, {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            text.setOrigin(0.5)

            tableContainer.add(text, 0, rowIndex + 1, 'center', 0, false);

            
            let shareAmountValue = "-"
            if(row.share_amount > 0){
                shareAmountValue = `$` +formatNumberWithCommas(row.share_amount);
            }

            const share_amount = this.add.text(0, 0, shareAmountValue , {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            share_amount.setOrigin(0.5)

            tableContainer.add(share_amount, 1, rowIndex + 1, 'center', 0, false);

            let winnerCount = "-"
            if(row.winners > 0){
                winnerCount =  parseFloat(row.winners).toLocaleString( 'en-US',{ minimumFractionDigits: 0, maximumFractionDigits: 0 });
            }

            const winners = this.add.text(0, 0, winnerCount, {
                fontSize: '24px',
                fontFamily: 'Montserrat',
                color: '#F9F9FF',
                align: 'center',
                lineSpacing: 10,
                wordWrap: { width:  186*2, useAdvancedWrap: true }
            });
            winners.setOrigin(0.5)

            tableContainer.add(winners, 2, rowIndex + 1, 'center', 0, false);

            
            
        });

        return tableContainer;
    }

}